import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'


export const MobilemenuCollectionCatagoryMappingListing = ({mobilemenuCollectionCatagoryMappingData, handleClick, editEnabled}) => {

    const [operationEntityProductMapping, setOperationEntityProductMapping] = useState([]);

    const contentRowNames = ["menuName", "isActive"]

    useEffect(() => {
        trackPromise(
            setOperationEntityProductMappingData()
            )
    }, [mobilemenuCollectionCatagoryMappingData]);

    async function setOperationEntityProductMappingData() { 
        destroyDataTable();
        await setOperationEntityProductMapping(mobilemenuCollectionCatagoryMappingData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? 
                (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>)
                :<td key={index}>{da[row] + " "}</td>
            )
         )
    });

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive row-top-gap">
                        <table id="example" className="display dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Menu Name</th>
                                    <th>Status</th>
                                    {editEnabled ? <th>Action</th> : null}
                                </tr>
                            </thead>
                            <tbody>
                                {operationEntityProductMapping.map((data, i) => {
                                    return (
                                        <tr key={i}>
                                            {content(data)}
                                            {editEnabled ? <td 
                                                onClick={() => handleClick(data)} 
                                                style={{cursor: "pointer"}}>
                                                <i className="far fa-edit"></i>
                                            </td> : null}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}


